
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { useState, useEffect } from 'react';
import { bondingCurveDB } from '../lib/bonding-curve-db';
import { CurveState } from '../types/bonding-curve';

export const useBondingCurve = (mintAddress?: string) => {
    const [curve, setCurve] = useState<CurveState | null>(null);

    useEffect(() => {
        if (!mintAddress) return;

        // Initial fetch
        const data = bondingCurveDB.getCurve(mintAddress);
        if (data) setCurve(data);
        else {
            // If checking a token that hasn't been initialized in our memory yet (e.g. from static list)
            // Initialize it with random state for demo purposes if it's not a freshly minted one
            // In real app, this would fetch on-chain account data
            const chain = mintAddress.startsWith('0x') ? 'SUI' : 'SOL';
            const newCurve = bondingCurveDB.initializeCurve(mintAddress, chain);
            setCurve(newCurve);
        }

        // Subscribe to changes
        const unsubscribe = bondingCurveDB.subscribe(() => {
            const updated = bondingCurveDB.getCurve(mintAddress);
            if (updated) setCurve({ ...updated });
        });

        return () => unsubscribe();
    }, [mintAddress]);

    return curve;
};
